import { adminUsersSegmentForProfile, loadAdminUserProfile } from "@/features/admin/api/adminUserProfileRoute";
import { createFileRoute, redirect } from "@tanstack/react-router";

const USER_PROFILE_ROUTES = {
    patients: "/users/patients/$userId",
    clinicians: "/users/clinicians/$userId",
    managers: "/users/managers/$userId",
    secretaries: "/users/secretaries/$userId",
    admins: "/users/admins/$userId",
} as const;

export const Route = createFileRoute("/_app/admin/user/$userId")({
    beforeLoad: async ({ context, params }) => {
        const { profile } = await loadAdminUserProfile(context.queryClient, params.userId);
        const segment = adminUsersSegmentForProfile(profile);
        throw redirect({
            to: USER_PROFILE_ROUTES[segment],
            params: { userId: params.userId },
        });
    },
    component: () => null,
});
